import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { SearchFormBase } from "../../../../../components/common/search-form-base/search-form-base";
import { AppServiceHelperService } from "../../../../../services/app-service-helper.service";
import { EventBusService } from "../../../../../services/event-bus.service";

/**
 * Property search form
 */
@Component({
  selector: 'property-search-form',
  templateUrl: './property-search-form.component.html',
  styleUrls: ['./property-search-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PropertySearchFormComponent extends SearchFormBase<any> implements OnInit {
  /**
   * Selected item
   */
  @Input() selectedItem: any;

  /**
   * Selected item type
   */
  @Input() selectedItemType: any = null;

  /**
   * Search event name (event bus)
   */
  protected get searchEventName(): string {
    return 'comparables.property.search';
  }

  /**
   * Show all event name (event bus)
   */
  protected get showAllEventName(): string {
    return 'comparables.property.showAll';
  }

  /**
   * Constructor
   * @param eventBus
   * @param httpClient
   * @param appServiceHelper
   */
  constructor(eventBus: EventBusService, httpClient: HttpClient, appServiceHelper: AppServiceHelperService) {
    super(eventBus, httpClient, 'resetComparablesSearchForm', appServiceHelper);
  }

  /**
   *OnInit
   */
  ngOnInit(): void {
    this.requireReflist('ref_lease_transaction_building_energy');
    this.init().then(() => {
      //Nothing
    });
  }

  /**
   * Gets the filter object
   * @param form
   * @returns
   */
  protected getFilterObject(form: UntypedFormGroup) {
    const filter = {
      logic: "and",
      filters: [],
      serverFilters: []
    };

    const controls = form.controls;

    this.addFilterNoStorage(filter, form, 'puid', 'ProjectStdIDDescription', 'contains');
    this.addFilterNoStorage(filter, form, 'buildingName', 'buildingName', 'contains');
    this.addFilterNoStorage(filter, form, 'municipalManual', 'MunicipalManual', 'contains');
    this.addFilterNoStorage(filter, form, 'postalCodeManual', 'PostalCodeManual', 'contains');
    this.addFilterNoStorage(filter, form, 'street', 'Street1', 'contains');
    this.addFilterNoStorage(filter, form, 'propertyType', 'PropertyType', 'contains');
    this.addFilterNoStorage(filter, form, 'propertySubType', 'PropertySubType', 'contains');

    if (controls.yearOfConstructionFrom.value || controls.yearOfConstructionTo.value) {
      filter.filters.push({
        field: 'BuildingYear',
        value: controls.yearOfConstructionFrom.value + '-' + controls.yearOfConstructionTo.value
        , operator: "contains"
        , serverValue: "{ from: " + (controls.yearOfConstructionFrom.value || "null") + ", to: " + (controls.yearOfConstructionTo.value || "null") + " }"
      });
    }
    if (controls.totalLettableAreaFrom.value || controls.totalLettableAreaTo.value) {
      filter.filters.push({
        field: 'TotalLettableArea',
        value: controls.totalLettableAreaFrom.value + '-' + controls.totalLettableAreaTo.value,
        operator: "contains"
        , serverValue: "{ from: " + (controls.totalLettableAreaFrom.value || "null") + ", to: " + (controls.totalLettableAreaTo.value || "null") + " }"
      });
    }

    this.addFilterNoStorage(filter, form, 'energyPerformanceLabelId', 'EnergyLabel', 'eq');
    return filter;
  }

  /**
   * Initialize the form data
   * @returns
   */
  protected async initFormData(): Promise<any> {
    const values = {
      puid: '',
      buildingName: '',
      municipalManual: '',
      postalCodeManual: '',
      street: '',
      propertyType: '',
      propertySubType: '',
      yearOfConstructionFrom: '',
      yearOfConstructionTo: '',
      totalLettableAreaFrom: '',
      totalLettableAreaTo: '',
      energyPerformanceLabelId: 0
    };

    return values;
  }

  /**
   * Initialize form with default data
  */
  protected createFormGroup(data: any): UntypedFormGroup {
    return new UntypedFormGroup({
      puid: new UntypedFormControl(data.puid),
      buildingName: new UntypedFormControl(data.buildingName),
      municipalManual: new UntypedFormControl(data.municipalManual),
      postalCodeManual: new UntypedFormControl(data.postalCodeManual),
      street: new UntypedFormControl(data.street),
      propertyType: new UntypedFormControl(data.propertyType),
      propertySubType: new UntypedFormControl(data.propertySubType),
      yearOfConstructionFrom: new UntypedFormControl(data.yearOfConstructionFrom),
      yearOfConstructionTo: new UntypedFormControl(data.yearOfConstructionTo),
      totalLettableAreaFrom: new UntypedFormControl(data.totalLettableAreaFrom),
      totalLettableAreaTo: new UntypedFormControl(data.totalLettableAreaTo),
      energyPerformanceLabelId: new UntypedFormControl(data.energyPerformanceLabelId)
    });
  }

  /**
   * Reset form
  */
  protected reset(): void {
    this.formData.reset();
    this.formData.controls['energyPerformanceLabelId'].setValue(0);
  }
}
